import { render } from "./Immersion.vue?vue&type=template&id=2aa3edea&lang=pug"
import script from "./Immersion.vue?vue&type=script&lang=ts"
export * from "./Immersion.vue?vue&type=script&lang=ts"

import "./Immersion.vue?vue&type=style&index=0&id=2aa3edea&lang=scss"
script.render = render

export default script